/** Helpers for staged listings ingested from the WhatsApp automation platform */

export function isWhatsAppStagedItem(item) {
  if (!item) return false;
  if (item.sourceSlug === 'whatsapp-platform') return true;
  if (item.sourceType === 'whatsapp_platform') return true;
  return Boolean(item.detailPayload?.whatsapp);
}

export function getWhatsAppStagedContext(item) {
  const wa = item?.detailPayload?.whatsapp;
  if (!wa && !isWhatsAppStagedItem(item)) return null;
  return {
    sourceChatTitle: wa?.sourceChatTitle || null,
    destinationChatTitle: wa?.destinationChatTitle || null,
    ruleName: wa?.ruleName || null,
    sentAt: wa?.sentAt || null,
    platformMessageId: wa?.platformMessageId || null,
    forwardId: wa?.forwardId || null,
    mediaUrl: wa?.mediaUrl || null,
    category: wa?.category || null,
  };
}

export function formatWhatsAppSentAt(sentAt) {
  if (!sentAt) return null;
  const d = new Date(sentAt);
  if (Number.isNaN(d.getTime())) return sentAt;
  return d.toLocaleString();
}

export function whatsAppRawBody(item) {
  if (item?.description?.trim()) return item.description.trim();
  return '';
}
